<template>
  <el-dialog
    v-dialogDrag
    :title="$t('enterprise.synchronizeEnterprise')"
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    width="527px"
    class="self-dialog-form"
  >
    <!-- form表单形式搜索 -->
    <el-form ref="ruleForm" :model="form" :label-position="'top'">
      <el-form-item :label="$t('enterprise.enterpriseName')">
        <el-popover
          ref="popover"
          v-model="popoverVisible"
          placement="bottom"
          :visible-arrow="false"
          popper-class="scim-common-theme scim-common-theme-green"
          trigger="manual"
          width="490"
        >
          <el-input
            slot="reference"
            v-model.trim="form.name"
            style="width: 100%"
            :placeholder="$t('enterprise.enterEnterpriseName')"
            @input="startSearch"
            @blur="popoverVisible = false"
            @focus="focusSearch"
          >
            <i slot="suffix" class="el-input__icon el-icon-search" @click="startSearch"></i>
          </el-input>
          <div class="self-popover-items">
            <div v-if="popoverLoading" class="self-popover-items-loading">
              <span v-loading="popoverLoading"></span>
            </div>
            <p
              v-for="(cm, index) in searchResult"
              :key="index"
              class="self-popover-item"
              @click="selectedItem(cm)"
            >
              {{ cm.tenantName }}
            </p>
          </div>
        </el-popover>
      </el-form-item>
      <el-form-item v-if="enterpriseInfo.tenantId" :label="$t('route.enterpriseInfo')">
        <!-- 企业详细信息 -->
        <div class="enterprise_list_warp">
          <!-- 头像，做法暂时与页面右上角保持一致 -->
          <div slot="reference" class="avatar-container">
            <div class="avatar-wrapper">
              <div v-if="enterpriseInfo.tenantName" class="user-avatar">
                {{ enterpriseInfo.tenantName.slice(0, 1) }}
              </div>
            </div>
          </div>
          <div class="enter_info">
            <div class="enter-info-detail">
              <label class="info-detail-title">{{ $t('enterprise.enterpriseName') }}：</label>
              <label class="info-detail-content">
                {{ enterpriseInfo.tenantName || $t('public.noAvailable') }}
              </label>
            </div>
            <div class="enter-info-detail">
              <label class="info-detail-title">
                {{ $t('enterprise.unifiedSocialCreditCode') }}：
              </label>
              <label class="info-detail-content">
                {{ enterpriseInfo.socialCreditCode || $t('public.noAvailable') }}
              </label>
            </div>

            <div class="enter-info-detail">
              <label class="info-detail-title">{{ $t('enterprise.address') }}：</label>
              <label class="info-detail-content">
                {{ enterpriseInfo.address || $t('public.noAvailable') }}
              </label>
            </div>
            <div class="enter-info-detail">
              <label class="info-detail-title">{{ $t('enterprise.administrator') }}：</label>
              <label class="info-detail-content">
                {{ enterpriseInfo.superAdmin.displayName || $t('public.noAvailable') }}
              </label>
            </div>
            <div class="enter-info-detail">
              <label class="info-detail-title">{{ $t('enterprise.phoneNumber') }}：</label>
              <label class="info-detail-content">
                {{ enterpriseInfo.superAdmin.cellphone || $t('public.noAvailable') }}
              </label>
            </div>
            <div class="enter-info-detail">
              <label class="info-detail-title">{{ $t('enterprise.email') }}：</label>
              <label class="info-detail-content">
                {{ enterpriseInfo.superAdmin.email || $t('public.noAvailable') }}
              </label>
            </div>
            <div class="enter-info-detail">
              <label class="info-detail-title">{{ $t('enterprise.account') }}：</label>
              <label class="info-detail-content">
                {{ enterpriseInfo.superAdmin.userName || $t('public.noAvailable') }}
              </label>
            </div>
          </div>
        </div>
      </el-form-item>
      <el-form-item label="管理员密码" v-if="enterpriseInfo.tenantId">
        <el-input show-password v-model="form.password"></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="cancel()">{{ $t('public.cancel') }}</el-button>
      <el-button
        :loading="ayncLoading"
        type="primary"
        :disabled="!enterpriseInfo.tenantId || !form.password"
        @click="ayncCustom()"
      >
        {{ $t('enterprise.synchronize') }}
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import BusinessApi from "@/api/business";
export default {
  name: "SyncBusiness",
  props: {
    visible: Boolean
  },
  data() {
    return {
      searchResult: [],
      form: {
        name: "",
        password: ""
      },
      // 企业详情
      enterpriseInfo: {},
      popoverVisible: false,
      ayncLoading: false,
      popoverLoading: false,
      timeout: null
    };
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.formKey = new Date().getTime();
        this.$nextTick(() => {
          this.form.name = "";
          this.enterpriseInfo = JSON.parse(JSON.stringify({}));
        });
        this.$emit("update:visible", val);
      }
    }
  },
  watch: {},
  created() {},
  mounted() {},

  methods: {
    // 搜索
    startSearch() {
      this.searchResult = [];

      clearTimeout(this.timeout);
      if (this.form.name) {
        this.popoverLoading = true;
        this.popoverVisible = true;
        this.timeout = setTimeout(() => {
          BusinessApi.searchCustom({ tenantName: this.form.name })
            .then(res => {
              this.popoverLoading = false;
              const { data = [] } = res;
              this.searchResult = data;
              if (!data.length) {
                this.popoverVisible = false;
              }
              // this.popoverVisible = !!data.length;
            })
            .catch(() => {
              this.popoverLoading = false;
              this.popoverVisible = false;
              this.searchResult = [];
            });
        }, 1000);
      } else {
        this.popoverLoading = false;
        this.popoverVisible = false;
      }
    },
    selectedItem(item) {
      this.enterpriseInfo = item;
      this.popoverVisible = false;
    },
    cancel() {
      this.dialogVisible = false;
    },
    ayncCustom() {
      this.ayncLoading = true;
      BusinessApi.ayncCustom({ tenantId: this.enterpriseInfo.tenantId, adminPassword: this.form.password })
        .then(res => {
          this.dialogVisible = false;
          this.ayncLoading = false;
          this.$message.success(this.$t("enterprise.syncSuccess"));
          this.$emit("success");
        })
        .catch(() => {
          this.ayncLoading = false;
        });
    },
    focusSearch() {
      if (this.form.name) {
        this.popoverVisible = true;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.enterprise_list_warp {
  display: flex;
  align-items: center;
  width: 100%;
  background-color: #f5f7fa;
  padding: 24px 16px 24px 16px;
  .avatar-container {
    height: 100%;
    display: flex;
    align-items: center;
    width: 80px;
    .avatar-wrapper {
      height: 32px;
      position: relative;
      cursor: default;
      .user-avatar {
        width: 32px;
        height: 32px;
        border-radius: 16px;
        background-color: #00b259;
        text-align: center;
        align-items: center;
        line-height: 30px;
        font-size: 14px;
        color: #fff;
      }
    }
    .pover_nopointer {
      cursor: default;
    }
  }
  .enter_info {
    height: 100%;
    .enter-info-detail {
      display: flex;
      width: 100%;
      line-height: 20px;
      margin-bottom: 8px;
      color: #505363;
      font-weight: 500;
      .info-detail-title {
        display: inline-block;
      }
      .info-detail-content {
        display: inline-block;
        line-height: 20px;
      }
    }
  }
  .el-icon-delete {
    display: none;
    cursor: pointer;
  }
  &:hover {
    .el-icon-delete {
      display: block;
      color: #e60000;
    }
  }
}
.address-tip {
  .tip-label {
    padding-left: 8px;
    font-weight: 400;
    color: #9ea5b2;
    font-size: 12px;
  }
}

.self-popover-items {
  height: 300px;
  overflow-y: auto;
  .self-popover-items-loading {
    text-align: center;
  }
  ::v-deep .el-loading-spinner {
    line-height: 300px;
    text-align: center;
  }
}
</style>
